import React, { useState } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import useAuth from '../../hooks/authentication/useAuth';
import { Box, FormControl, Typography } from '@mui/material';
import PrimaryBtn from '../shared/Buttons/PrimaryButton';
import TextFieldStyled from '../shared/TextFieldStyled';
import { PATTERNS } from '../../utils/constans/constans';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { AuthPageTitle } from '../shared/Typography/AuthenticationsPageTitle';
import { SubmitButtonWrapper } from '../styled/Form/SubmitButtonWrapper';
import { ErrorTypography } from '../styled/ErrorTypography';

export const LoginForm = () => {
    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm<FormValues>();

    const { t } = useTranslation();
    const auth = useAuth();
    const url = process.env.REACT_APP_SHOPIFY_STORE_URL;

    const [isLoading, setIsLoading] = useState(false);
    const [hasError, setHasError] = useState(false);

    const onSubmit: SubmitHandler<FormValues> = (data) => {
        setIsLoading(true);
        setHasError(false);
        auth.loginForRedirect(data.emailAddress, data.password)
            .then((res) => {
                window.location.replace(
                    url +
                        '/account/login/multipass/' +
                        res.getData().shopify_login_token
                );
            })
            .catch((err) => {
                if (err.data.email) {
                    setHasError(true);
                }
                setIsLoading(false);
            });
    };

    return (
        <>
            <AuthPageTitle>{t('LOGIN_PAGE.LOGIN').toString()}</AuthPageTitle>
            <form onSubmit={handleSubmit(onSubmit)}>
                {/* Email address */}
                <FormControl fullWidth>
                    <TextFieldStyled
                        label={t('LOGIN_FORM_FIELDS.EMAIL').toString()}
                        error={!!errors.emailAddress}
                        {...register('emailAddress', {
                            required: t(
                                'FORM_VALIDATION_ERROR.REQUIRED'
                            ).toString(),
                            pattern: {
                                value: PATTERNS.VALID_EMAIL,
                                message: t(
                                    'FORM_VALIDATION_ERROR.EMAIL'
                                ).toString(),
                            },
                        })}
                        helperText={
                            errors.emailAddress
                                ? errors.emailAddress.message
                                : ' '
                        }
                    />
                </FormControl>
                <FormControl fullWidth>
                    <TextFieldStyled
                        label={t('LOGIN_FORM_FIELDS.PASSWORD').toString()}
                        error={!!errors.password}
                        type="password"
                        {...register('password', {
                            required: t(
                                'FORM_VALIDATION_ERROR.REQUIRED'
                            ).toString(),
                        })}
                        helperText={
                            errors.password ? errors.password.message : ' '
                        }
                    />
                </FormControl>
                <Typography paragraph>
                    <Link to="/forgot-password">
                        {t('LOGIN_FORM_FIELDS.FORGOT_PASSWORD').toString()}
                    </Link>
                </Typography>
                {hasError && (
                    <Box sx={{ paddingBottom: '10px' }}>
                        <ErrorTypography errorCode={'LOGIN_ERROR_PLUS_1'} />
                        <ErrorTypography errorCode={'LOGIN_ERROR_PLUS_2'} />
                    </Box>
                )}
                <SubmitButtonWrapper>
                    <PrimaryBtn
                        type="submit"
                        sx={{
                            width: '100%',
                        }}
                        disabled={isLoading}
                    >
                        {t('LOGIN_FORM_FIELDS.LOGIN').toString()}
                    </PrimaryBtn>
                </SubmitButtonWrapper>
            </form>
        </>
    );
};

type FormValues = {
    emailAddress: string;
    password: string;
};
